import { usePromptGoogleOneTap as useSharedPromptGoogleOneTap } from 'components/shared/usePromptGoogleOneTap';

import { setShouldPresentMarketModalOnLS } from '../MarketSelectorModal';

export function usePromptGoogleOneTap(
  source: 'gallery' | 'pdp' | 'login' | 'homepage',
  { disablePromptGoogleOneTap }: { disablePromptGoogleOneTap?: boolean } = {},
) {
  useSharedPromptGoogleOneTap(
    `cosmos-exclusive-${source}`,
    () => setShouldPresentMarketModalOnLS(true),
    disablePromptGoogleOneTap,
  );
}
